{
  "app": {
    "title": "Facturación",
    "close_button": "Cerrar",
    "loading": "Cargando..."
  },
  "orders_dashboard": {
    "title": "Pedidos",
    "filter_all": "Todo",
    "filter_unassigned": "Sin asignar",
    "filter_expiring": "Expira pronto",
    "filter_undeployed": "Disponible para desplegar",
    "filter_canActivate": "Disponible para activar",
    "search_orders": "Buscar ordenes"
  },
  "orders_list": {
    "subscriptionExpiry": "VENCIMIENTO DE LA SUSCRIPCIÓN",
    "end_of_orders_list": "lista de fin de pedidos",
    "orderDate": "FECHA DE PEDIDO",
    "orderNumber": "NÚMERO DEL PEDIDO",
    "subscriptionNumber": "NÚMERO DE SUSCRIPCIÓN",
    "accountName": "CUENTA ASIGNADA",
    "unassigned": "Sin asignar",
    "unavailable": "No disponible",
    "expiring": "EXPIRA PRONTO",
    "assign": "ASIGNAR",
    "expired": "VENCIDO",
    "perpetual": "PERMANENTE",
    "pending": "ACTIVACIÓN PENDIENTE",
    "error_retrieving_orders": "Se produjo un error al recuperar los pedidos.",
    "no_orders_found": "No se encontraron pedidos.",
    "deploy": "Desplegar",
    "activate": "Activar"
  },
  "order_details": {
    "deploy_button": "Desplegar",
    "activate_button": "Activar",
    "assign_button": "Asignar",
    "order_number": "Orden #",
    "tracking_number": "Número de Rastreo",
    "subscription_number": "# de Suscripción",
    "see_additional_details": "Ver detalles de seguimiento adicionales",
    "hide_additional_details": "Contraer detalles de seguimiento adicionales",
    "po_number": "Número de PO del revendedor",
    "reseller_SAP_Id": "ID de distribuidor en SAP",
    "sapOrderId": "ID de Pedido en SAP",
    "order_assigned_to": "Orden asignada a",
    "start_date": "Fecha de inicio",
    "term": "Término",
    "please_pick_acct_msg": "No pudimos hacer coincidir este pedido, así que seleccione manualmente una cuenta para aplicarla.",
    "company": "Empresa",
    "create_new_account": "Crear una nueva cuenta",
    "order_expiry_time": "EL PEDIDO EXPIRARÁ EN {{numdays}} DÍAS",
    "licenses": "Licencias",
    "license": "Licencia",
    "customerSapId": "ID de SAP de cliente",
    "customerPONumber": "Número de pedido del cliente",
    "search_companies": "Buscar empresas",
    "month": "Mes",
    "year": "Año",
    "day": "Día",
    "unknown": "Desconocido",
    "assigning_account_to_order": "Asignación de orden a cuenta...",
    "deploying_order": "Orden desplegándose...",
    "activating_order": "Activando orden...",
    "error_assigning_order": "Se produjo un error al asignar el pedido a la cuenta.",
    "error_deploying_order": "Hubo un error al desplegar el pedido.",
    "error_activating_order": "Hubo un error al activar el pedido.",
    "cannot_comm_parent": "No podemos redirigirlo al formulario adecuado. Puede crear una cuenta desde la aplicación Cuentas.",
    "no_results_found": "No se han obtenido resultados",
    "existing-subscription": "Falló la asignación: esta empresa ya tiene un pedido.",
    "0001": "Licencias insuficientes. El número de licencias gratuitas asignadas ({free}) excede el número de licencias ({paid}) en el pedido pagado.",
    "restricted_view_warning": "Funciones desactivadas. Tu acceso está restringido."
  },
  "order_complete": {
    "go-to-account-integrations": "Ir a integraciones de cuentas",
    "go-to-account": "Ir a la cuenta",
    "activate-order": "Activar pedido",
    "order-added": "¡Pedido añadido!",
    "order-deployed": "¡Pedido desplegado!",
    "order-activated": "¡Pedido activado!",
    "enable-integration": "Solo una nota, para que funcionen los ítems de este pedido, requieren de una integración para ser configurados y habilitados.",
    "activate-order-instructions": "Solo una nota: este pedido debe activarse para funcionar."
  },
  "errors": {
    "504-general-message": "La solución está ocupada o inalcanzable. Por favor, inténtalo de nuevo.",
    "couldnt-find-order": "No encontramos el pedido en la lista. Por favor, vuelve a cargar la página."
  }
}